import {
    JustpayConfigurationEndpointService
} from "@/views/loyalty/shared/endpoint_services/justpay-configuration-endpoint-service"

export class JustpayConfigurationService {
    constructor (store) {
        this.justpayConfigurationEndpointService = new JustpayConfigurationEndpointService(store)
    }

    async copyConf (configurationId) {
        return this.justpayConfigurationEndpointService.copyConf(configurationId)
    }

    async getConfById (confId) {
        return this.justpayConfigurationEndpointService.getList({ id: confId })
    }
}
